<template>
  <div>
    <el-card shadow="always">
      <el-input size="small" style="width: 280px" placeholder="搜索关键字" clearable v-model.trim="params.keyword" @change="getData()">
        <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
      </el-input>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
      <span style="margin: 0 5px; font-size: 14px">日期</span>
      <el-date-picker v-model="params.date_range" type="daterange" value-format="yyyy-MM-dd" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getData()" style="width: 200px"> </el-date-picker>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="employee_name" label="姓名" width="120"></el-table-column>
      <el-table-column prop="department_name" label="部门" width="120"></el-table-column>
      <el-table-column prop="content" label="小结" width="400" show-overflow-tooltip> </el-table-column>
      <el-table-column label="提交时间" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
  </div>
</template>

<script>
// import Department from "@/components/department/select.vue";
export default {
  name: 'employeeDailyLog',
  components: {
    // Department
  },
  created() {
    this.getData()
  },
  data() {
    return {
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: '',
        date_range: []
      }
    }
  },
  methods: {
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params)

      await this.$api.dailyLog.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page
      this.getData()
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize
      this.getData()
    },
    //刷新
    refresh() {
      this.getData()
    }
  }
}
</script>
